import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { BillingFrequency, PackageId } from "media/js/pricing/api/types";
import { toCurrency } from "media/js/pricing/plan-builder-2023/common/util";
import { PACKAGE_ID_TO_LINK } from "media/js/pricing/plan-builder-2023/types";
import { CheckboxEl } from "common/components/checkbox";
import { TrackingEvents } from "media/js/pricing/tracking";
const MP2023PackageDescriptions = {
  [PackageId.DATA_WAREHOUSE_EXPORT]: `With this add-on, you can spend less time cleaning and preparing your data, and export events and user profiles created in Mixpanel to your cloud storage for custom analysis.`,
  [PackageId.GROUP_ANALYTICS]: `Measure KPIs at the account or company level. B2B companies can use this add-on to prevent churn and discover upsell opportunities based on group-level product usage.`
};
export function template() {
  const selectedPricingCurve = this.app.helpers.getCurrentPricingCurve();
  const selectedPlanState = this.app.helpers.getSelectedPlanState();
  const userLacksBillingPerms = this.helpers.userLacksBillingPermissions();
  const packages = selectedPricingCurve.packages.map((packageOption) => {
    var _a;
    const selected = (_a = selectedPlanState.packageIds) == null ? void 0 : _a.includes(packageOption.id);
    const isAnnual = selectedPlanState.billingFrequency === BillingFrequency.ANNUAL;
    return /* @__PURE__ */ jsx("div", {
      sel: ".package-option-wrapper",
      on: {
        ...this.attr(`mp-2023-style`) && {
          click: () => this.helpers.handlePackageClick(packageOption.id),
          keydown: (ev) => {
            (ev.key === `Enter` || ev.key === ` `) && this.helpers.handlePackageClick(packageOption.id);
          }
        }
      }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".package-option-top-row"
    }, this.attr(`mp-2023-style`) ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".package-option-title"
    }, packageOption.name), /* @__PURE__ */ jsx(CheckboxEl, {
      sel: ".package-option-checkbox",
      attrs: {
        checked: selected,
        "checked-color": `#7856ff`,
        tabindex: 0,
        "style-override": `.mp-checkbox-wrapper .mp-checkbox-icon {margin-right: 0px;}`
      }
    })) : /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-font-size-medium.package-option-title"
    }, packageOption.name), /* @__PURE__ */ jsx("div", {
      sel: ".package-option-pricing"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-font-size-medium.package-option-price"
    }, `${toCurrency(this.app.helpers.getPackagePrice(packageOption.id))} ${isAnnual ? `per year` : `per month`}`), /* @__PURE__ */ jsx("div", {
      sel: ".package-option-plan-pct"
    }, "(", packageOption.basePlanPct * 100, "% of base plan)"))), !this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: ButtonTheme.Secondary
      },
      on: { click: () => this.helpers.handlePackageClick(packageOption.id) }
    }, selected ? /* @__PURE__ */ jsx(null, null, "Remove") : `Add`)), this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".package-option-pricing"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".package-option-price"
    }, toCurrency(this.app.helpers.getPackagePrice(packageOption.id))), /* @__PURE__ */ jsx("div", {
      sel: ".package-option-plan-pct"
    }, packageOption.basePlanPct * 100, "% of base plan ", isAnnual ? `per year` : `per month`)), /* @__PURE__ */ jsx("div", {
      sel: ".horizontal-line"
    })), /* @__PURE__ */ jsx("div", {
      sel: ".package-option-description"
    }, this.attr(`mp-2023-style`) ? MP2023PackageDescriptions[packageOption.id] : packageOption.description), !this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx("a", {
      sel: ".package-option-link",
      attrs: { href: PACKAGE_ID_TO_LINK[packageOption.id], target: `_blank` }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".package-option-learn-more"
    }, "Learn More"), " ", /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `arrow-right` }
    })));
  });
  const adminInfoCard = () => {
    return userLacksBillingPerms && this.state.owners && /* @__PURE__ */ jsx("div", {
      sel: ".info-area"
    }, `Please contact your org owner to make changes to your plan: `, this.state.owners.map((owner, index) => /* @__PURE__ */ jsx(null, null, index > 0 && /* @__PURE__ */ jsx(null, null, `, `), /* @__PURE__ */ jsx("a", {
      attrs: { href: `mailto:${owner.email}` }
    }, owner.email))));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: this.attr(`mp-2023-style`) && `.package-step-wrapper`
  }, /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, this.attr(`mp-2023-style`) ? `Customize your plan with additional features` : `Customize Your Plan With Additional Features`), /* @__PURE__ */ jsx("div", {
    sel: ".step-description"
  }, "Add-ons are optional and give you access to more Mixpanel features. They are priced as a percentage of your base (Events) plan. You can choose to add or remove an add-on at any time throughout your billing cycle."), /* @__PURE__ */ jsx("div", {
    sel: ".package-options"
  }, packages), this.attr(`mp-2023-style`) && adminInfoCard(), /* @__PURE__ */ jsx("div", {
    sel: ".button-tooltip-area"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
      role: `button`,
      tabindex: 0,
      disabled: userLacksBillingPerms,
      size: ButtonSize.Large
    },
    on: { click: () => this.helpers.handleContinue() },
    sel: ".continue-button"
  }, this.attr(`unauthed`) ? `Sign Up or Log In to Continue` : `Continue`), this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx("a", {
    sel: ".support-button",
    attrs: {
      role: `button`,
      tabindex: 0,
      href: `/get-support`,
      target: `_blank`
    },
    on: { click: () => this.app.helpers.trackEventWithPlanProps(TrackingEvents.ContactSupport) }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-help` }
  }), "Contact support"), !this.attr(`mp-2023-style`) && userLacksBillingPerms && this.state.owners && /* @__PURE__ */ jsx("div", {
    sel: ".info-icon-area"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` },
    sel: ".info-icon"
  }), /* @__PURE__ */ jsx("div", null, `Please contact your org owner (`, this.state.owners.map((owner, index) => /* @__PURE__ */ jsx(null, null, index > 0 && /* @__PURE__ */ jsx(null, null, `, `), /* @__PURE__ */ jsx("a", {
    attrs: { href: `mailto:${owner.email}` }
  }, owner.email))), `) to make changes to your plan.`))));
}
